import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

const SEO = ({
  title = "Lloyd Consulting AB — Financial Crime Compliance Specialists",
  description = "Strategic financial crime compliance advisory for Swedish financial institutions. AML, FIDAC reporting, MLRO support, AMLA & DORA readiness.",
  ogTitle,
  ogDescription,
  ogType = "website",
}: SEOProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={ogTitle || title} />
    <meta property="og:description" content={ogDescription || description} />
    <meta property="og:type" content={ogType} />
  </Helmet>
);

export default SEO;
